import React from 'react';
import {
    Button,
    useUpdateMany,
    useRefresh,
    useNotify,
    useUnselectAll,
} from 'react-admin';
import DoneIcon from '@mui/icons-material/Done';

const EnableButton = (params) => {
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany, { loading }] = useUpdateMany(
        params.resource,
        params.selectedIds,
        { enabled: true },
        {
            onSuccess: () => {
                refresh();
                notify('Items enabled');
                unselectAll(params.resource);
            },
            onFailure: error =>
                notify('Error: items are not updated', 'warning'),
        },
    );

    return (
        <Button color="primary" label="Enable" disabled={loading} onClick={updateMany}>
            <DoneIcon />
        </Button>
    );
};

export default EnableButton;